let stripe = null;
let valueClient = null;
let elements = null;
let type_request = null;
let paymentElement = null;
let flag_precio = null;
let data_element = null;


export function main() {
    const form = document.getElementById('payment-form');
    type_request = $("input[name=type_request]").val()
    if ((type_request != "tlmk" && $("#enrollment-id-input").val() != "" && $("#preOrderData").val() != "ERROR - PREORDER") || (type_request == "tlmk")) {

        data_element = (type_request == "tlmk") ? JSON.parse($("input[name=dato]").val()) : getElements(JSON.parse($("#preOrderData").val()).order);
        flag_precio = data_element.Precio;
        let urlMain = (flag_precio > 0) ? '/PaymentToken/getClientForm' : '/PaymentToken/getClientCardForm';

        $.ajax({
            url: '' + urlMain,
            type: 'Post',
            data: data_element,
            success: function (response) {
                const lenguaje = {
                    locale: response.len
                };
                stripe = Stripe(response.key, lenguaje);
                valueClient = response.clientSecret;
                const appearance = {
                    theme: 'stripe',
                };

                const { clientSecret } = { clientSecret: valueClient };
                elements = stripe.elements({ appearance, clientSecret });
                const paymentElementOptions = {
                    layout: "tabs",
                };
                if (flag_precio > 0) {
                    paymentElement = elements.create("payment", paymentElementOptions);
                } else {
                    setLoading(true);
                    var style = {
                        base: {
                            color: "#a4a5ab",
                            fontWeight: 500,
                            fontFamily: "Inter, Open Sans, Segoe UI, sans-serif",
                            fontSize: "16px",
                            fontSmoothing: "antialiased",

                            "::placeholder": {
                                color: "#CFD7DF"
                            }
                        },
                        invalid: {
                            color: "#E25950"
                        },
                    };

                    paymentElement = elements.create("card", { style: style, hidePostalCode: true });
                }

                paymentElement.mount("#payment-element");
                if (flag_precio < 1) {
                    $("#payment-element").css({
                        "border": "1px solid #cfd7df",
                        "border-radius": "5px",
                        "height": "45px",
                        "padding-top": "10px",
                        "padding-left": "5px"
                    });
                    setLoading(false);


                }


                if (type_request == "tlmk") {
                    document.querySelector("#pay-button").disabled = true;
                    setTimeout(hideSpinnerTlmk(), 5000);
                } else {
                    document.querySelector("#pay-button").disabled = false;
                }
                console.log("terminando ...");
            },
            error: function (errorThrown) {
                alert(errorThrown);
            }
        });

    }

    $(document).ready(function () {
        form.addEventListener('submit', function (e) {

            e.preventDefault();
            setLoading(true);
            let status = null;
            if (type_request != "tlmk") {
                $("#pay-button").hide();
                tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", true);
            }
            const generatePromise = () => {
                return new Promise((resolve, reject) => {
                    if (flag_precio > 0) {
                        stripe.confirmPayment({
                            elements,
                            confirmParams: {},
                            redirect: 'if_required'
                        }).then((result) => {
                            resolve(result);

                        }).catch((error) => {
                            reject(error);
                        });
                    } else {

                        stripe.confirmCardSetup(valueClient, {
                            payment_method: {
                                card: paymentElement,
                                billing_details: { email: data_element.email }
                            }
                        })
                            .then(function (result) {
                                resolve(result);
                            }).catch((error) => {
                                reject(error);
                            });
                    }

                });
            };

            generatePromise().then((result) => {
                validate(result);
            }).catch((error) => {
                console.log("generatePromise error:" + error);
                console.log(error);
                setLoading(false);
                hideSpinnerTlmk();
                showMessage("Error, intente nuevamente");
            });
        }
        );
    });


}

function getElements(elements) {

    let plazosStripe = $('#input-plazos').val();
    let precioStripe = (plazosStripe == 1) ? elements.precio : JSON.parse($("#priceInfo").val()).InitialQuotaPrice;
    return {
        NumPedido: elements.numPedido,
        Idioma: "es",
        Email: elements.email,
        NombreApellidos: elements.nombreApellidos,
        Precio: precioStripe,
        CurrencyCode: $("#currencyCode").val(),
        Titulo: elements.titulo,
        Nif: elements.nif,
        IdPaymentTlmk: 0,
        Nplazos: plazosStripe,
        Pais: $("#countryCode").val()
    }

}



function validate(result) {
    if (result.paymentIntent) {
        status = result.paymentIntent.status;
        setLoading(false);
        if (status == "succeeded") {
            if (type_request == "tlmk") {
                $("#payment-form").submit();
                //window.location.href = `${window.location.origin}/PaymentToken/order-info/${$("input[name=TokenPedido]").val()}`; 
            } else {
                tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", false);
                tech.newEnrollment.submitEnrollmentForm();
            }
        }

    }
    if (result.setupIntent) {
        status = result.setupIntent.status;
        setLoading(false);
        if (status == "succeeded") {
            if (type_request == "tlmk") {
                $("#payment-form").submit();
                //window.location.href = `${window.location.origin}/PaymentToken/order-info/${$("input[name=TokenPedido]").val()}`;
            } else {
                console.log(status)
            }
        }
    }
    if (result.error) {
        setLoading(false);
        hideSpinnerTlmk();
        showMessage(result.error.message);
        if (type_request != "tlmk") {
            $("#pay-button").show();
            tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", false);
        }


    }
}
function showMessage(messageText) {
    $("#payment-message").html(messageText)
    setTimeout(function () { $("#payment-message").html(""); }, 15000);
}
function setLoading(isLoading) {
    if (isLoading) {
        if (type_request == "tlmk") {
            document.querySelector("#spinner").classList.remove("hidden");
            document.querySelector("#button-text").classList.add("hidden");
        } else {
            document.querySelector("#button-label").classList.add("hidden");
        }
        document.querySelector("#pay-button").disabled = true;


    } else {
        if (type_request == "tlmk") {
            document.querySelector("#spinner").classList.add("hidden");
            document.querySelector("#button-text").classList.remove("hidden");
        } else {
            document.querySelector("#button-label").classList.remove("hidden");
        }
        document.querySelector("#pay-button").disabled = false;


    }
}
function hideSpinnerTlmk() {
    $("#payment-spinner-tlmk").css({ "display": "none", "margin- top": "0em" });
    $("#payment-spinner").css({ "display": "none", "margin- top": "0em" });
    $('#payment-spinner-tlmk-message').text('');
    $(".payment-form-wrapper").css({ "display": "block" });
    $("#my-payment-form").css({ "display": "block" });
    $("#pay-button").css({ "display": "block" });
}